import { render } from "./RolePermissionTab.vue?vue&type=template&id=7a7337b2&scoped=true"
import script from "./RolePermissionTab.vue?vue&type=script&lang=js"
export * from "./RolePermissionTab.vue?vue&type=script&lang=js"

import "./RolePermissionTab.vue?vue&type=style&index=0&id=7a7337b2&lang=scss&scoped=true"
import "./RolePermissionTab.vue?vue&type=style&index=1&id=7a7337b2&lang=scss"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.22.1.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a7337b2"]])

export default __exports__